import React from 'react';
import { ArrowLeft } from 'lucide-react';
import { Link } from 'react-router-dom';
import { useThemeStore } from '../stores/themeStore';

export default function RGPDPage() {
  const { darkMode } = useThemeStore();
  
  return (
    <div className="max-w-4xl mx-auto py-8">
      <div className="mb-8">
        <Link
          to="/"
          className={`flex items-center ${darkMode ? 'text-gray-300 hover:text-white' : 'text-gray-600 hover:text-blue-600'}`}
        >
          <ArrowLeft className="w-5 h-5 mr-2" />
          Retour à l'accueil
        </Link>
      </div>
      
      <div className={`${darkMode ? 'bg-gray-800' : 'bg-white'} rounded-xl shadow-sm p-8`}>
        <h1 className={`text-2xl font-bold mb-6 ${darkMode ? 'text-white' : 'text-gray-900'}`}>Politique de confidentialité</h1>
        <p className={`text-sm ${darkMode ? 'text-gray-400' : 'text-gray-500'} mb-6`}>Dernière mise à jour : 27 juin 2025</p>

        <div className="space-y-6">
          <section>
            <h2 className={`text-xl font-semibold mb-3 ${darkMode ? 'text-white' : 'text-gray-900'}`}>1. Responsable du traitement</h2>
            <p className={darkMode ? 'text-gray-300' : 'text-gray-700'}>
              CRM Reclassement – crm-emploi.com<br />
              Porteur de projet : Samuel LUCAS<br />
              Contact : contact@anthea-rh.com
            </p>
          </section>

          <section>
            <h2 className={`text-xl font-semibold mb-3 ${darkMode ? 'text-white' : 'text-gray-900'}`}>2. Données collectées</h2>
            <p className={darkMode ? 'text-gray-300' : 'text-gray-700'}>
              Nous collectons uniquement les données strictement nécessaires au bon fonctionnement de notre plateforme, notamment :
            </p>
            <ul className={`list-disc pl-6 mt-2 ${darkMode ? 'text-gray-300' : 'text-gray-700'}`}>
              <li>Données d'identification : nom, prénom, email, numéro de téléphone</li>
              <li>Données de connexion : adresse IP, logs, horodatage</li>
              <li>Données professionnelles : CV, expériences, projets, disponibilités</li>
              <li>Données de navigation : via cookies</li>
            </ul>
          </section>

          <section>
            <h2 className={`text-xl font-semibold mb-3 ${darkMode ? 'text-white' : 'text-gray-900'}`}>3. Finalités du traitement</h2>
            <p className={darkMode ? 'text-gray-300' : 'text-gray-700'}>
              Vos données sont utilisées pour :
            </p>
            <ul className={`list-disc pl-6 mt-2 ${darkMode ? 'text-gray-300' : 'text-gray-700'}`}>
              <li>Vous créer un compte sécurisé</li>
              <li>Gérer votre parcours professionnel (candidatures, rendez-vous, documents)</li>
              <li>Communiquer avec les recruteurs ou les conseillers</li>
              <li>Établir des statistiques d'usage (anonymisées)</li>
            </ul>
          </section>

          <section>
            <h2 className={`text-xl font-semibold mb-3 ${darkMode ? 'text-white' : 'text-gray-900'}`}>4. Base légale</h2>
            <p className={darkMode ? 'text-gray-300' : 'text-gray-700'}>
              Les traitements réalisés sont fondés sur :
            </p>
            <ul className={`list-disc pl-6 mt-2 ${darkMode ? 'text-gray-300' : 'text-gray-700'}`}>
              <li>Votre consentement (formulaire, cookies)</li>
              <li>L'exécution d'un contrat (inscription et utilisation de l'application)</li>
              <li>Notre intérêt légitime (amélioration continue du service)</li>
            </ul>
          </section>

          <section>
            <h2 className={`text-xl font-semibold mb-3 ${darkMode ? 'text-white' : 'text-gray-900'}`}>5. Durée de conservation</h2>
            <ul className={`list-disc pl-6 ${darkMode ? 'text-gray-300' : 'text-gray-700'}`}>
              <li>Données de compte : jusqu'à 3 ans après la dernière activité</li>
              <li>Données de candidature : 2 ans maximum</li>
              <li>Cookies : 13 mois maximum</li>
            </ul>
            <p className={`mt-2 ${darkMode ? 'text-gray-300' : 'text-gray-700'}`}>
              Vous pouvez demander à tout moment la suppression de vos données.
            </p>
          </section>

          <section>
            <h2 className={`text-xl font-semibold mb-3 ${darkMode ? 'text-white' : 'text-gray-900'}`}>6. Destinataires</h2>
            <p className={darkMode ? 'text-gray-300' : 'text-gray-700'}>
              Vos données sont accessibles uniquement :
            </p>
            <ul className={`list-disc pl-6 mt-2 ${darkMode ? 'text-gray-300' : 'text-gray-700'}`}>
              <li>À l'équipe CRM Reclassement (administration et support)</li>
              <li>À nos prestataires techniques sous contrat (Firebase – Google Cloud Platform, hébergement Hostinger)</li>
              <li>À certains tiers dans le cadre strict d'un accompagnement professionnel (avec votre consentement)</li>
            </ul>
            <p className={`mt-2 ${darkMode ? 'text-gray-300' : 'text-gray-700'}`}>
              Aucun transfert non sécurisé ou non encadré hors UE n'est effectué.
            </p>
          </section>

          <section>
            <h2 className={`text-xl font-semibold mb-3 ${darkMode ? 'text-white' : 'text-gray-900'}`}>7. Cookies</h2>
            <p className={darkMode ? 'text-gray-300' : 'text-gray-700'}>
              Nous utilisons des cookies strictement nécessaires au fonctionnement du site, ainsi que des cookies analytiques. 
              Vous pouvez accepter ou refuser les cookies à tout moment via le bandeau affiché à votre première visite.
            </p>
          </section>

          <section>
            <h2 className={`text-xl font-semibold mb-3 ${darkMode ? 'text-white' : 'text-gray-900'}`}>8. Vos droits RGPD</h2>
            <p className={darkMode ? 'text-gray-300' : 'text-gray-700'}>
              Conformément au RGPD, vous disposez des droits suivants :
            </p>
            <ul className={`list-disc pl-6 mt-2 ${darkMode ? 'text-gray-300' : 'text-gray-700'}`}>
              <li>Accès à vos données</li>
              <li>Rectification</li>
              <li>Suppression (« droit à l'oubli »)</li>
              <li>Limitation du traitement</li>
              <li>Portabilité</li>
              <li>Opposition</li>
            </ul>
            <p className={`mt-2 ${darkMode ? 'text-gray-300' : 'text-gray-700'}`}>
              Pour exercer vos droits : dpo@anthea-rh.com
            </p>
          </section>

          <section>
            <h2 className={`text-xl font-semibold mb-3 ${darkMode ? 'text-white' : 'text-gray-900'}`}>9. Sécurité des données</h2>
            <p className={darkMode ? 'text-gray-300' : 'text-gray-700'}>
              Nous appliquons des mesures techniques et organisationnelles robustes :
            </p>
            <ul className={`list-disc pl-6 mt-2 ${darkMode ? 'text-gray-300' : 'text-gray-700'}`}>
              <li>Authentification forte (Firebase Auth)</li>
              <li>Chiffrement des données en transit (HTTPS)</li>
              <li>Sécurisation des accès back-office</li>
              <li>Sauvegardes régulières et surveillance de l'infrastructure</li>
            </ul>
          </section>

          <section>
            <h2 className={`text-xl font-semibold mb-3 ${darkMode ? 'text-white' : 'text-gray-900'}`}>10. Modifications de la politique</h2>
            <p className={darkMode ? 'text-gray-300' : 'text-gray-700'}>
              Nous nous réservons le droit de mettre à jour la présente politique. La version applicable est celle en vigueur au moment de votre visite.
            </p>
          </section>

          <section>
            <h2 className={`text-xl font-semibold mb-3 ${darkMode ? 'text-white' : 'text-gray-900'}`}>📩 Contact</h2>
            <p className={darkMode ? 'text-gray-300' : 'text-gray-700'}>
              Pour toute question sur cette politique ou vos données personnelles : dpo@anthea-rh.com.
            </p>
          </section>
        </div>
      </div>
    </div>
  );
}